import { useTranslation } from '@gimlite/common';
import { WizardItemType } from '@gimlite/ui-v1';
import { useEffect } from 'react';
import { ProductCategoryEnum } from '../../../../client/graphql';
import { ProductForm } from '../../../../form/product/product.form';
import { CreateNewSingleContractWizardContext } from '../../createNewSingleContract.wizard';

export const ProductStep = ({
  context: { product, parkingId, contractBase },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewSingleContractWizardContext>) => {
  const { t, lang } = useTranslation();

  useEffect(() => {
    validate(!!product.id);
  }, [product]);

  return parkingId ? (
    <ProductForm
      handleEvent={{
        select: ({
          id,
          period,
          APBMode,
          credentials,
          duration,
          articleCodes,
        }) => {
          submit({
            product: {
              period,
              id,
              credentials: credentials || [],
              duration,
              articleCodes,
            },
            contractBase: {
              ...contractBase,
              startDate: new Date().toISOString(),
              APBMode: APBMode,
              articleCode: articleCodes[0]?.code || null,
            },
            credentials: {
              actived: [],
              desactived: [],
              context: 'wizardNewContract',
            },
            contractSearchSelect: null,
            addFakeQRCODE: false,
          });
        },
      }}
      data={{
        parkingId,
        productId: product.id,
        category: ProductCategoryEnum.PeriodSubscription,
      }}
    />
  ) : null;
};
